var map = {
	"./feature_4_0.jpg": 602,
	"./feature_4_1.jpg": 566,
	"./feature_4_2.jpg": 400,
	"./feature_4_3.jpg": 36,
	"./feature_4_4.jpg": 205,
	"./feature_4_5.jpg": 532
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59;